/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Modal from "@material-ui/core/Modal";
import { CSVLink } from "react-csv";
import BookDataService from "../../services/BookService";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import "./usageData.css";

import UsageDoughnutChart from "../charts/UsageDoughnutChart";

const UsageDataModal = ({ open, onClose, domainName }) => {
  const [monthlyUsage, setMonthlyUsage] = useState([]);
  const [usageData, setUsageData] = useState([]);
  const [totalVisits, setTotalVisits] = useState(0);
  const [month, setMonth] = useState("01");
  const [year, setYear] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [totalPercentageSum, setTotalPercentageSum] = useState(0);

  const DateRangePicker = ({
    startDate,
    setStartDate,
    endDate,
    setEndDate,
  }) => {
    const onChange = (dates) => {
      const [start, end] = dates;
      setStartDate(start);
      setEndDate(end);
    };
    return (
      <DatePicker
        selected={startDate}
        onChange={onChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        inline
      />
    );
  };

  function calculatePercentage(part, whole) {
    if (typeof part !== "number" || typeof whole !== "number" || whole === 0) {
      return null;
    }
    const percentage = (part / whole) * 100;

    return Math.round(percentage * 100) / 100;
  }
  // Import your updated service function

  const checkByMonth = async (startDate, endDate) => {
    // console.log({ startDate, endDate });

    setLoading(true);
    try {
      const res = await BookDataService.getUsageDataByDateRange(
        startDate,
        endDate
      );

      setMonthlyUsage(Object.entries(res.data));

      setLoading(false);
      setError(false);
    } catch (e) {
      setLoading(false);
      setError(true);
      console.log("error fetching user data: ", e);
    }
  };

  useEffect(() => {
    let totalVisits = monthlyUsage.reduce((acc, book) => {
      return acc + book[1].totalUniqueVisits;
    }, 0);

    setTotalVisits(totalVisits);

    let totalPercentage = monthlyUsage.reduce((acc, book) => {
      let percentage = calculatePercentage(
        book[1].totalUniqueVisits,
        totalVisits
      );
      return acc + (percentage || 0); // Adding null check in case percentage is null
    }, 0);

    setTotalPercentageSum(totalPercentage);

    console.log("Total Percentage of Usage:", totalPercentage);
  }, [monthlyUsage]);

  const formatDate = (date) => {
    return date.toISOString().split("T")[0]; // This will format the date to YYYY-MM-DD
  };

  const sortUsageData = (data) => {
    const sortedAndFilteredBooks = data
      .filter(
        // Ehsan wants these books filtered out from the usage data report as they are samples
        (book) =>
          book[1].title !== "Practice Pal Tutorial" &&
          book[1].title !== "Lágrima (sample version)"
      )
      .sort((a, b) => {
        const usageA = calculatePercentage(a[1].totalUniqueVisits, totalVisits);
        const usageB = calculatePercentage(b[1].totalUniqueVisits, totalVisits);
        return usageB - usageA; // Descending order
      });

    console.log("sortedAndFilteredBooks");
    console.log(sortedAndFilteredBooks);
    return sortedAndFilteredBooks;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);
    checkByMonth(formattedStartDate, formattedEndDate);
  };

  const headers = [
    { label: "book title", key: "title" },
    { label: "total visits for this month", key: "dailyVisits" },
    { label: "percentage used of total visits", key: "percent" },
    { label: "unique users", key: "uniqueUsers" },
    { label: "notes", key: "" },
  ];

  const csvReport = {
    filename: `${domainName}${startDate}/${endDate}report.csv`,
    headers: headers,
    data: monthlyUsage,
  };

  return (
    <Modal open={open} onClose={onClose} className="add-modal">
      <div
        className="add-modal-content"
        style={{ maxHeight: "800px", overflowY: "scroll" }}
      >
        <h1 className="text-red-500 font-fold underline">
          Usage data for {domainName}
        </h1>
        <form onSubmit={onSubmit}>
          <div className="flex-container">
            <label>Date Range: </label>
            <DateRangePicker
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
            />
          </div>

          {/* <label>enter month: </label>
          <select
            style={{ padding: "5px 10px" }}
            onChange={(e) => handleMonth(e.target.value)}
          >
            <option value="01">January</option>
            <option value="02">February</option>
            <option value="03">March</option>
            <option value="04">April</option>
            <option value="05">May</option>
            <option value="06">June</option>
            <option value="07">July</option>
            <option value="08">August</option>
            <option value="09">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>
          <label style={{ marginLeft: "15px" }}>enter year:</label>
          <input
            style={{ width: "120px" }}
            type="text"
            name="year"
            value={year}
            onChange={(e) => handleYear(e.target.value)}
          /> */}

          <button
            type="submit"
            style={{
              margin: "12px 0",
              padding: "5px 15px",
              width: "100%",
              height: "auto",
              border: "none",
              color: "white",
              backgroundColor: "green",
              borderRadius: "5px",
            }}
          >
            apply
          </button>
        </form>
        {!loading && monthlyUsage.length > 0 ? (
          <CSVLink
            style={{
              border: "none",
              padding: "5px 15px",
              borderRadius: "5px",
              backgroundColor: "red",
              color: "white",
              textDecoration: "none",
            }}
            {...csvReport}
          >
            download
          </CSVLink>
        ) : (
          ""
        )}

        {startDate && endDate && !loading && monthlyUsage.length > 0 ? (
          <h3 style={{ width: "100%" }}>Top 20 results</h3>
        ) : (
          ""
        )}
        {!error && !loading && monthlyUsage && (
          <UsageDoughnutChart monthlyUsage={monthlyUsage} />
        )}

        {startDate && endDate && !loading && monthlyUsage.length > 0 ? (
          <h3 style={{ width: "100%" }}>
            {formatDate(startDate)} / {formatDate(endDate)}
          </h3>
        ) : (
          ""
        )}
        {!error && !loading && monthlyUsage
          ? sortUsageData([...monthlyUsage]).map((book, i) => {
              return (
                <div style={{ width: "100%" }} key={book[0]}>
                  <p
                    style={{
                      marginRight: "5px",
                      marginBottom: "0",
                      backgroundColor: "lightgray",
                      padding: "5px",
                      borderRadius: "5px",
                    }}
                  >
                    {book[1].title}
                  </p>
                  <div style={{ display: "flex" }}>
                    <p style={{ marginRight: "5px" }}>
                      {" "}
                      total unique visits:{" "}
                      <span style={{ color: "red" }}>
                        {book[1].totalUniqueVisits}{" "}
                      </span>
                    </p>
                    <p>
                      usage percentage:{" "}
                      <span style={{ color: "purple" }}>
                        {calculatePercentage(
                          book[1].totalUniqueVisits,
                          totalVisits
                        )}{" "}
                        %
                      </span>
                    </p>
                    <p style={{ marginLeft: "10px" }}>
                      Total Visits (not unique){" "}
                      <span style={{ color: "orange" }}>
                        {book[1].totalVisits}
                      </span>
                    </p>
                  </div>
                </div>
              );
            })
          : ""}
        {!error && loading && (
          <div>
            Loading usage data. This will probably take several seconds...
          </div>
        )}
        {error && <div>There was an error loading usage data.</div>}
      </div>
    </Modal>
  );
};

export default UsageDataModal;
